import React, { useEffect, useState } from "react";
import useSWR from "swr";
import { AddBtn } from "components/common/button";
import { OnelineNoticeListTable, AddModal } from "components/onelineNotice";
import { PrimayPagination } from "components/common/pagination";
import type { IOnelineNoticeList } from "service/interface/notice";

export function OnelineNoticeListPage() {
  const [selectPage, setSelectPage] = useState<number>(1);
  const [listData, setListData] = useState<{
    count: number;
    data: IOnelineNoticeList[];
  }>({ count: 0, data: [] });
  const [isAddModalVisible, setIsAddModalVisible] = useState<boolean>(false);
  const { data, mutate } = useSWR(
    `/admin/manage/onelinenotice?limit=12&offset=${selectPage * 12 - 12}`,
  );

  useEffect(() => {
    if (data) {
      setListData(data);
    }
  }, [data]);

  const handleAddBtn = () => {
    setIsAddModalVisible(true);
  };

  return (
    <>
      <AddModal
        isVisible={isAddModalVisible}
        setIsVisible={setIsAddModalVisible}
        mutate={mutate}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_55px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
            한줄 공지 관리
          </p>
          <div className="mb-[24px] mt-[16px] flex items-center justify-end">
            <AddBtn onClick={handleAddBtn} />
          </div>
          <OnelineNoticeListTable data={listData.data} />
          <div className="mt-[32px] flex justify-end">
            <PrimayPagination
              listLength={Math.ceil(listData.count / 12)}
              pageNumber={selectPage}
              setPageNumber={setSelectPage}
            />
          </div>
        </div>
      </div>
    </>
  );
}
